import {MESSAGE_RCPT_GROUP} from "./abstract/const";
import {AbstractTypingMessage} from "./abstract/typing/abstract-typing-message.model";

/**
 * Модель уведомления о начале/окончании набора сообщения в группе
 */
export class TypingMessageGroup extends AbstractTypingMessage {
    constructor() {
        super();
        this.header.rcpt = MESSAGE_RCPT_GROUP;
    }
}